import React, {useCallback, useEffect, useState} from 'react';
import {useProjectState} from "../../context/project/ProjectIndex";
import {createProductColumnRenderers} from "./Columns";

const ProductItemRow = ({data, visibleColumns}) => {
  const projectState = useProjectState()
  const [product, setProduct] = useState(data);
  const COLUMN_RENDERERS = React.useMemo(() => createProductColumnRenderers(), []);

  useEffect(() => {
    setProduct(data)
  }, [data]);

  const getColumnProps = useCallback((columnId) => {
    const baseProps = {product, projectState};
    return baseProps;
  }, [product, projectState]);

  return (
    <>
      <tr>
        {visibleColumns.map(columnId => {
          const renderColumn = COLUMN_RENDERERS[columnId];
          if (!renderColumn) {
            // Log missing column renderer for debugging
            console.warn(`No renderer found for column: ${columnId}`);
            return null;
          }

          const props = getColumnProps(columnId);
          return (
            <React.Fragment key={columnId}>
              {renderColumn(props)}
            </React.Fragment>
          );
        })}
      </tr>
    </>
  )
}

export default ProductItemRow;
